import { BaseService } from '@common/http-layer/service/base.service'

export interface PageHitInput {
  eventType: string
  locationId: string
  path: string
  flavor: string // app flavor: clientportal | gokollab | courses
  appType: string // sidebar section (courses | communities | affiliates | …), else the app flavor
  action: string
  sub_action: string
  contactId?: string
  userId?: string
  /** Event-specific properties (opt-in via `pendoProperties`); the base fields above always win. */
  extraProperties?: Record<string, string | number | boolean>
}

class ClientPortalAnalyticsService extends BaseService {
  constructor() {
    // Hit the clientportal-analytics service directly (not the /clientclub middleware). locationId
    // travels in the body, so the path is static.
    super({ baseURL: 'CLIENTPORTAL_ANALYTICS_SERVER_URL' })
  }

  // Fire-and-forget — non-blocking + keepalive so navigation/unload never breaks; errors swallowed.
  trackPageHit({
    eventType,
    locationId,
    path,
    flavor,
    appType,
    action,
    sub_action,
    contactId,
    userId,
    extraProperties,
  }: PageHitInput): void {
    const properties: Record<string, string | number | boolean> = {
      ...extraProperties,
      path,
      platform: 'web',
      flavor,
      appType,
      action,
      sub_action,
    }
    if (contactId) properties.contactId = contactId
    if (userId) properties.userid = userId

    const endpoint = '/track/events'

    void (async () => {
      try {
        await this.post(endpoint, { eventType, locationId, properties }, { keepalive: true })
      } catch (error) {
        this.logger.error('[ClientPortalAnalytics] page-hit failed', { error: error as Error, eventType, locationId })
      }
    })()
  }
}

export const clientPortalAnalyticsService = new ClientPortalAnalyticsService()
